<template>
    <div class="modal-bill" v-if="isVisible">
			<div class="container-modal-bill">
				<div class="section-bill">
						<v-flex text-xs-right pr-2>
							<v-icon @click="$emit('close-modal')">cancel</v-icon>
						</v-flex>
						<div class="con-accommodation">
							<div class="container-accommodation">
								<p class="text-accommodation border-bottom">Alojamiento</p>
								<p class="text-accommodation">Monto Total</p>
								<input type="text" readonly="readonly" class="input-accomodation" v-model="amountTotal" placeholder="0">
							</div>
							<div class="container-rode" v-for="index in dateBill" :key="index.id">
								<p class="text-rode">Monto</p>
								<input type="number" class="input-accomodation" v-model="index.price">

							</div>
						</div>
					<v-layout justify-center align-content-center row my-3>
						<v-flex text-xs-center>
							<v-btn
							class="btn-cancel grey"
						 	@click="$emit('cancel-modal')">
							Cancelar
						</v-btn>
						<v-btn
							class="btn-action btn-save"
							@click="$emit('save-modal', dateBill, idDetail)"
							:disabled="!printSave"
							>
							Guardar
						</v-btn>
						</v-flex>
					</v-layout>
        </div>
			</div>
    </div>
</template>

<script>
import selectButton from '@/clerkinn/shared/select-button';
import inputText from '@/clerkinn/shared/input-text';
import { required } from 'vuelidate/lib/validators';

function printSave() {
	return Number(this.dateBill[0].price) + Number(this.dateBill[1].price) === this.amountTotal;
}

function validations() {
	return {
		dateBill: {
			price: {
				required,
			},
		},
	};
}

function data() {
	return {
		dateBill: [
			{
				id: 0,
				price: 0,
			},
			{
				id: 1,
				price: 0,
			},
		],
	};
}

export default {
	name: 'modal-bill',
	data,
	validations,
	computed: {
		printSave,
	},
	props: {
		amountTotal: {
			default: false,
			type: [Number, String],
		},
		isVisible: {
			default: false,
			type: Boolean,
		},
		idDetail: {
			default: false,
			type: [Number, String],
		},
	},
	components: {
		selectButton,
		inputText,
	},
};
</script>

<style lang="scss" scoped>
.container-rode {
	padding: 10px;
}

.text-rode {
	color: #afafaf;
	font-size: 13px;
	margin-bottom: 3px;
	text-align: center;
}

.container-accommodation {
	align-items: center;
	background: #303645;
	border: #000000;
	color: #ffffff;
	display: flex;
	flex-direction: column;
	width: 211px;
}

.container-modal-bill {
	align-items: center;
	background: rgba(0, 0, 0, 0.42);
	bottom: 0;
	content: '';
	display: flex;
	height: 100%;
	justify-content: center;
	left: 0;
	position: fixed;
	right: 0;
	top: 0;
	width: 100%;
	z-index: 10;
}

.section-bill {
	background: #ffffff;
	width: 475px;
}

.text-accommodation {
	font-size: 14px;
	margin-bottom: 3px;
	padding: 5px;
	text-align: center;
}

.border-bottom {
	border-bottom: 1px solid #000000;
	width: 100%;
}

.input-accomodation {
	background-color: #ffffff;
	box-shadow: inset 0 2px 5px 0 rgba(0, 0, 0, 0.2);
	color: #818181;
  	height: 25px;
	margin-bottom: 10px;
	outline: none;
	text-align: center;
	width: 80px;
}

.con-accommodation {
	align-items: center;
	border: 1px solid #000000;
	display: flex;
  	flex-direction: column;
	left: 50%;
	margin-bottom: 22px;
  	position: relative;
  	transform: translateX(-50%);
	width: 211px;																																																																													
}
</style>



// WEBPACK FOOTER //
// modal-bill.vue?8817f4f6